export default "__VITE_ASSET__bda7a38d__"